import React, { Component } from 'react';
import './style.css';
import { HeaderQuestion, NextQuestionButton } from '../../components';
import { Trans, translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

class Opposite extends Component {
  constructor(props) {
    super(props);
    let opposite = props.pair.answer.opposite || '';
    this.state = {
      value: opposite,
      charsLeft: this.props.maxLength - opposite.length
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({
      value: event.target.value,
      charsLeft: this.props.maxLength - event.target.value.length
    });
  }

  render() {
    const { t } = this.props;
    const term = this.props.term;
    const maxLength = this.props.maxLength;
    const charsLeft = this.state.charsLeft;
    const description = (
      <Trans i18nKey="opposite">What is the opposite of {{ term }}?</Trans>
    );
    return (
      <div className="card-body">
        <form onSubmit={this.handleSubmit}>
          <HeaderQuestion
            text=""
            description={description}
            skip={this.props.skip}
            pairId={this.props.pair.pairId}
          />
          <div className="App-answer-text instructions">
            <Trans i18nKey="maxLetters">
              Max. {{ maxLength }} letters ({{ charsLeft }} left):
            </Trans>
          </div>
          <div className="input-group App-answer-text App-answer">
            <input
              autoFocus
              type="text"
              className="form-control"
              onChange={this.handleChange}
              value={this.state.value}
              maxLength={this.props.maxLength}
            />
          </div>
          <NextQuestionButton
            to={this.props.url}
            onClick={() => this.props.save(this.state.value)}
            disabled={this.state.value ? false : true}
          />
          <div className="App-answer-button">
            <button
              className="btn btn-light btn-round btn-block"
              onClick={this.props.history.goBack}
            >
              {t('BACK')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(translate('translations')(Opposite));



// WEBPACK FOOTER //
// ./src/preference/components/Pair/opposite.js